module.exports = __webpack_public_path__ + "img/thunder.9d68045e.svg";